import { gql } from "@apollo/client";

/** Single activity body text for the reader dialog (content steps only). */
export const GET_ACTIVITY_QUERY = gql`
  query GetActivity($id: Int!) {
    activity(id: $id) {
      id
      title
      description
      contents {
        id
        sequenceOrder
        readableText
        ... on QuestionActivityContent {
          questionTypeLabel
          expectedAnswers {
            id
            expectedAnswerText
          }
        }
      }
      voiceMessage {
        id
        recordedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
